module.exports = __webpack_public_path__ + "img/Bitmap@261x.5e7079b4.png";